<script setup lang="ts">
import { onBeforeMount, ref, Ref } from "vue";
import { useApiClient } from "@/api/client";
import ModuleLoading from "@/ui/components/loading/moduleLoading.vue";
import { toastApiResult } from "@/toaster";
import { loadingWrapper } from "@/api/helpers/loadingWrapper";
import { useBaseStore } from "@/stores/base";
import NotificationEventsManager from "@/modules/users/components/NotificationEventsManager.vue";

const availableNotificationEvents: Ref<App.Data.NotificationEventDO[]> = ref();

const loadAvailableNotificationEvents = async () => {
	const response = await loadingWrapper(
		useApiClient("users").getAvailableNotificationEventsForProfile()
	);

	if (response.isOk()) {
		availableNotificationEvents.value = response.value;
	}
};

onBeforeMount(() => {
	loadAvailableNotificationEvents();
});

const updateNotificationEvents = async (
	notificationEvents: App.Data.NotificationEventDO[]
) => {
	await toastApiResult(
		useApiClient("users").updateNotificationEventsFromProfile(
			notificationEvents
		)
	);
};
</script>

<template>
	<module-loading>
		<v-card class="pa-5 mt-5" elevation="1">
			<notification-events-manager
				:async-update-function="updateNotificationEvents"
				:available-notification-events="availableNotificationEvents"
				:configured-notification-events="
					useBaseStore().currentUser.notificationEvents
				"
			/>
		</v-card>
	</module-loading>
</template>

<style lang="scss">
.v-expansion-panel-title__overlay {
	background: rgba(var(--v-theme-primary)) !important;
}
</style>
